module.exports = __webpack_public_path__ + "img/cont2.72f53737.png";